import { STATES } from 'common/domain/states';

const URL_VAC = '/vacations-absences/my-vacations-mobile';
const URL_FB = '/food-benefit/my-food-benefit';
const URL_LOANS = '/loans/my-creditworthiness';

const URL_PREQA = 'https://dev.autocertificados.bbva.com';
const URL_PRE = 'https://pre-autocertificados.bbva.com/';
const URL_PRO = 'https://autocertificados.bbva.com/';
class IndexController {
  constructor(
    UserDataService,
    AuthenticationService,
    ManagerDataService,
    $cookies,
    $window,
    $state
  ) {
    'ngInject';
    this.window = $window;
    this.userDataService = UserDataService;
    this.authenticationService = AuthenticationService;
    this.managerDataService = ManagerDataService;
    this.isMobileApp = $window.innerWidth < 1024;
    this.state = $state;
    this.redirect();

    this.isVisibleChangeEmployee = process.env.isDev;
    this.clean();

    this.userId = $cookies.get('userId');
    this.token = $cookies.get('token');

    switch (process.env.name) {
    case 'dev':
      this.baseUrl = URL_PREQA;
      break;

    case 'pre':
      this.baseUrl = URL_PRE;
      break;

    case 'pro':
      this.baseUrl = URL_PRO;
      break;
    }
  }

  clean() {
    this.userDataService.clean();
    this.managerDataService.clean();
  }

  redirect() {
    if (process.env.isDev) {
      this.state.go(STATES.INDEX);
      return;
    }

    if (this.isMobileApp) {
      this.mobileRedirect();
    } else {
      this.redirectToLogin();
    }
  }
  mobileRedirect() {
    const path = localStorage.getItem('path');

    if (!path) {
      this.redirectToLogin();
      return;
    }

    if (path === URL_LOANS) {
      this.state.go(STATES.LOANS.LOANS_CATALOG);
    }

    if (path === URL_FB) {
      this.state.go(STATES.FOOD_BENEFIT.MY_FOOD_BENEFIT);
    }

    if (path === URL_VAC) {
      this.state.go(STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE);
    }
  }

  redirectToLogin() {
    if (!this.authenticationService.isAuthenticated()) {
      return this.authenticationService.redirectToLogin();
    }
  }
}

export default IndexController;



// WEBPACK FOOTER //
// ./client/app/features/mainRouting/index/index.controller.js